<!-- views/referrerReport/List.vue -->
<template>
  <div class="referrer-report-container">
    <Card>
      <div class="filter-container">
        <Form :inline="true" :model="queryForm">
          <FormItem>
            <DatePicker
              v-model="queryForm.yearMonth"
              type="month"
              placeholder="选择年月"
              format="yyyy-MM"
              :options="pickerOptions"
              style="width: 200px">
            </DatePicker>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="handleQuery">查询</Button>
          </FormItem>
        </Form>
      </div>

      <Table
        :columns="columns"
        :data="reportList"
        :loading="loading"
        border
        stripe>
      </Table>
    </Card>
  </div>
</template>

<script>
import { getReferrerReport } from '@/api/referrerReport'

export default {
  data() {
    return {
      queryForm: {
        yearMonth: ''
      },
      columns: [
        {
          title: '推荐人昵称',
          key: 'nickname',
          align: 'center'
        },
        {
          title: '被推荐人下单金额',
          key: 'relAmount',
          align: 'center',
          sortable: true,
          render: (h, params) => {
            return h('span', {
              style: {
                color: '#19be6b',
                fontWeight: 'bold'
              }
            }, '¥' + (params.row.relAmount || 0))
          }
        },
        {
          title: '订单数',
          key: 'num',
          align: 'center',
          sortable: true
        },
        {
          title: '推荐人数',
          key: 'person',
          align: 'center',
          sortable: true
        },
        {
          title: '首次下单数',
          key: 'firstOrderNum',
          align: 'center',
          sortable: true
        }
      ],
      reportList: [],
      loading: false,
      total: 0,
      pickerOptions: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now()
        }
      }
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      const now = new Date()
      const year = now.getFullYear()
      const month = (now.getMonth() + 1).toString().padStart(2, '0')
      this.queryForm.yearMonth = new Date(`${year}-${month}-01`)
      this.fetchData()
    },
    async fetchData() {
      if (!this.queryForm.yearMonth) {
        this.$Message.warning('请选择年月')
        return
      }

      this.loading = true
      try {
        let yearMonth = this.queryForm.yearMonth
        if (this.queryForm.yearMonth instanceof Date) {
          const date = this.queryForm.yearMonth
          yearMonth = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}`
        }

        const params = {
          yearMonth
        }

        const response = await getReferrerReport(params)

        if (Array.isArray(response)) {
          this.reportList = response
          this.total = response.length
        } else if (response && response.data) {
          this.reportList = Array.isArray(response.data) ? response.data : []
          this.total = response.total || this.reportList.length
        } else {
          this.reportList = []
          this.total = 0
        }

        console.log('加载数据:', this.reportList.length, '条')
      } catch (error) {
        console.error('获取报表失败:', error)
        this.$Message.error('获取推荐人报表失败')
        this.reportList = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    handleQuery() {
      this.fetchData()
    }
  }
}
</script>

<style scoped lang="less">
.referrer-report-container {
  padding: 20px;
}

.filter-container {
  margin-bottom: 20px;
}
</style>
